export default __webpack_public_path__ + "f37d175265c882971427fc3445ae4b9b.png";